import { inject, Injectable } from '@angular/core';

import { IS_VOLATILE_VALUE_FN } from './local-storage.config';

@Injectable()
export class LocalStorageService {
  private readonly isVolatileValue = inject(IS_VOLATILE_VALUE_FN);

  public clearVolatileValues(): void {
    const items = { ...localStorage };
    Object.keys(items)
      .filter(key => this.isVolatileValue(key))
      .forEach(key => localStorage.removeItem(key));
  }
}
